const initialState = {
    commonReducer: {
        isLoading: false,
        serverError: {},
    },
    sessionReducer: {
        username: '',
        email: '',
        token: '',
        expiresAt: null,
    },
    domainReducer: {
        data: {},
        isSuccess: false,
        targetDomain: {},
    },
    getDomainsReducer: {
        domains: [],
        domainHistory: {},
    },
};

export default initialState;
